<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.roomNav.overview')" link="rooms" />
    <item-nav-group v-if="!isEmpty(rooms)" :open="true" :label="$t('layout.nav.admin.roomNav.rooms')">
      <item-nav-group-item v-for="room in rooms"
                           v-if="!room.deleted"
                           :label="getName(room)"
                           :params="routeParams(room.id)"
                           :key="room.id"
                           link="room" />
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(deletedRooms)" :open="false" :label="$t('layout.nav.admin.roomNav.deletedRooms')">
      <item-nav-group-item v-for="room in deletedRooms"
                           :label="getName(room)"
                           :params="routeParams(room.id)"
                           :key="room.id"
                           link="room" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'RoomNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      rooms: [],
    };
  },

  computed: {
    deletedRooms: function () {
      return this.rooms.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.axios.get(this.serviceUrls.room.list(this))
      .then((response) => {
        this.rooms = response.data.data;
      });

    this.$serviceBus.$on('room.list', (data) => {
      if (isNil(data)) {
        this.axios.get(this.serviceUrls.room.list(this))
          .then((response) => {
            this.rooms = response.data.data;
          });
      } else {
        this.rooms = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    getName(room) {
      if (isNil(room)) return '-';
      let ret = null;

      ret = room.roomNumber;

      if (room.deleted === false) {
        if (!isEmpty(room.name) && room.name !== room.roomNumber) {
          ret += ` (${room.name})`;
        }
      } else {
        const roomNumberParts = ret.split('::');
        if (roomNumberParts.length >= 2) ret = roomNumberParts[1];
      }

      return isEmpty(ret) ? '-' : ret;
    },
    routeParams(roomId) {
      return {
        roomId: roomId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/RoomNav.vue